import React from "react";
import { Image } from "@wss/image";
export interface Props {
  altText?: string;
  link?: string;
  logo?: string;
  imageBackground?: string;
}
const ImageTile = ({
  altText,
  link,
  logo,
  imageBackground
}: Props) => {
  return <div className="w-full h-auto lg:max-h-40 flex justify-center items-center" data-sentry-component="ImageTile" data-sentry-source-file="ImageTile.tsx">
      <a href={link} className="relative flex flex-1 justify-center items-center group">
        <Image src={logo} alt={altText} className="max-w-1/2 w-48 absolute z-10 h-auto" width={353} height={162} data-sentry-element="Image" data-sentry-source-file="ImageTile.tsx" />
        <Image src={imageBackground} alt="" loading="lazy" className="relative w-full h-auto rounded-t group-hover:opacity-90 transition-all ease-in-out duration-75 lg:max-h-40" width={20} height={9} data-sentry-element="Image" data-sentry-source-file="ImageTile.tsx" />
      </a>
    </div>;
};
export default ImageTile;